<div class="modal-header">
  <h4 class="modal-title">Reporte Tabla {{reporte}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Cancelar')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div id="modal-content-hmtl" class="modal-content-hmtl" [innerHTML]="contenido"></div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.close('Aceptar')">Aceptar</button>
  <button type="button" class="btn btn-info" (click)="Imprimir()">Imprimir</button>
  <button type="button" class="btn btn-success" (click)="Descargar()">Descargar</button>
</div>
